var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.items),function(item){return _c('v-flex',{key:item.id,attrs:{"xs6":"","pa-2":""}},[_c('label-row',{attrs:{"item":item}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }